import { render, staticRenderFns } from "./ChangeInformation.vue?vue&type=template&id=01d2e104&scoped=true"
import script from "./ChangeInformation.vue?vue&type=script&lang=js"
export * from "./ChangeInformation.vue?vue&type=script&lang=js"
import style0 from "./ChangeInformation.vue?vue&type=style&index=0&id=01d2e104&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d2e104",
  null
  
)

export default component.exports